<div class="dialogue-content">
  <div class="mat-dialogue-header">
    <h4>View More Session</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="cancel()"></button>
  </div>
  <mat-dialog-content class="">
    <div class="session-box position-relative p-0">
      <div class="class-box p-0 mb-3 d-block">
        <div class="row g-0 session-box session-box-top p-0">
          <div class="col-md-12 session-textbox ms-auto">
            <div class="session-search">
              <input maxlength="100" type="text" (keyup)="applyFilter($event)" placeholder="Search"
                class="form-control search-box" [(ngModel)]="searchString"
                oninput="this.value = this.value.replace(/^\s+/g, '')" />
              <i *ngIf="searchString !== ''" class="fa-solid fa-times search-icon" (click)="clearSearch()"></i>
              <i *ngIf="searchString === ''" class="fa-solid fa-magnifying-glass search-icon"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="class-box d-flex justify-content-between mb-3" *ngFor="let session of sessionList">
        <div>
          <h4 class="WrapData" title="{{ session.className }}">{{ session.className }}</h4>
          <p [innerHTML]="session.sessionStartDateTime | ordinalDate : session.sessionStartDateTime">
            <i class="fa-regular fa-calendar-days"></i>
          </p>
          <p>
            <i class="fa-regular fa-clock"></i> {{ session.sessionStartDateTime | date : dateFormat.shortTime }} - {{
            session.sessionEndDateTime | date : dateFormat.shortTime }}
          </p>
          <p class="d-inline-flex align-items-center flex-wrap gap-1"><span class="WrapData">- {{ session.hostedBy
              }}</span><label class="pointer" (click)="viewDescription(session)">View</label></p>
        </div>
        <a *ngIf="!session.isSoldOut" class="btn btn-primary h-50 mt-3" (click)="addPass(session)">
          Book <i class="fa-solid fa-arrow-right ms-2"></i>
        </a>

        <a *ngIf="session.isSoldOut" class="btn btn-primary h-50 mt-3 pointer bookedBtn">
          Sold Out
        </a>
      </div>
      <div *ngIf="sessionList.length === 0" class="text-center mt-3">
        No session found!
      </div>
    </div>
    <div class="modal-footer bg-white p-0 border-top-0">
      <div class="mt-2 w-100" *ngIf="sessionList.length > 0">
        <mat-paginator [length]="totalrecord" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
          aria-label="Select page" (page)="pageChanged($event)" [showFirstLastButtons]="true">
        </mat-paginator>
      </div>
      <div class="mt-3 d-flex align-items-center justify-content-center text-center w-100">
        <button class="btn btn-primary-outline previous-btn" (click)="cancel()">
          Previous
        </button>
      </div>
    </div>
  </mat-dialog-content>
</div>